module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-3-fill-2d604472.svg";